<template>
    <div class="calendar-view has-header">
        <div class="header">
            <div class="options">
                <div class="label" v-bind:class="{'selected': displayedTimeframe === 'Week'}" v-on:click="displayedTimeframe = 'Week'">W</div>
                <div class="label" v-bind:class="{'selected': displayedTimeframe === 'Month'}" v-on:click="displayedTimeframe = 'Month'">M</div>
                <div class="label" v-bind:class="{'selected': displayedTimeframe === 'Year'}" v-on:click="displayedTimeframe = 'Year'">Y</div>
            </div>
        </div>
        <div class="scrollbar-container">
            <div class="grid">
                <div class="column" v-for="(column, indexC) in columns" :key="indexC" v-bind:class="{today: today.month() === indexC}">
                    <div class="header">
                        <div class="label">{{column.header.label}}</div>
                    </div>
                    <div class="row" v-for="(row, indexR) in column.rows" :key="indexR" v-bind:class="{today: today.date() === indexR + 1, hide: row.employees.length === 0}" v-on:click="OpenCalendarPopup($event, column, row)">
                        <div class="header" v-if="indexC === 0">
                            <div class="label">{{row.header.label}}</div>
                        </div>
                        <div class="holiday">{{row.holidayCount}}</div>
                        <div class="holiday-request">{{row.holidayRequestCount}}</div>
                        <div class="sick">{{row.sickCount}}</div>
                        <div class="info"></div>
                        <div class="event"  v-if="row.event" v-on:mouseenter="MouseOnEvent($event, row.event)" v-on:mouseleave="eventOnHover = null">{{row.event ? 'Event' : ''}}</div>
                        <div class="event shadow"  v-if="row.event"></div>
                        <div class="today-border"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="event-info" v-if="eventOnHover" v-bind:style="{left: eventBoxX + 'px',top: eventBoxY + 'px'}">
            <div class="header">{{eventOnHover.header}}</div>
            <div class="description">{{eventOnHover.description}}</div>
        </div>
        <div v-if="loading" class="loading">
            <i class="fas fa-spinner"></i>
        </div>
        <calendarpopup ref="calendarpopup" :state="dayInfoState"/>
    </div>
</template>

<script>

    import calendarpopup from '../preferencecontext/CalendarInfoPopup.vue'
    var moment = require('moment');
    export default {
        name: 'calenderview',
        components: {
            calendarpopup,
        },
        data(){
            return{
                displayedTimeframe: 'Year',
                columns: [],
                eventOnHover: null,
                mouseX: 0,
                mouseY: 0,
                today: this.$helpers.getMomentUTC(),
                employees: [],
                employeesFiltered: [],
                employeeMap: {},
                preferences: {},
                businessUnits: [],
                businessUnitsMap: {},
                spots: [],
                spotMap: {},
                uiData: [],
                employeeAvailabilityStateMap: {},
                employeeAvailabilityTypeMap: {},
                loading: true,
                eventBoxX: '',
                eventBoxY: '',
                dayInfoState: {
                    toggled: false,
                    column: null,
                    row: null,
                    employees: [],
                    event: null,
                    elRelative: null,
                    preferences: [],
                    date: this.$helpers.getCurrentMonthMomentUTC(),
                },
                storeEventMap: {},

            }
        },
        created() {
            this.Init();
        },
        mounted() {
        },
        beforeDestroy(){

            if(this.$refs.calendarpopup && this.$refs.calendarpopup.$el) $(this.$refs.calendarpopup.$el).remove();
        },
        methods: {
            MouseOnEvent($event, event){
                this.eventOnHover = event;
                var box = $event.currentTarget.getBoundingClientRect();
                this.eventBoxX = box.left - (box.width * .5);
                this.eventBoxY = box.bottom + 5;
            },
            Init(){
                var view = this;
                this.loading = true;

                view.loadUIData().then(response=> {
                    view.updateUIData(response.data);
                    return view.loadStoreEvents();
                    }).then(response=> {
                    view.updateStoreEvents(response.data);
                    return view.loadActiveEmployees().then(response => {
                        view.employeeMap = {};
                        view.employees = response.data;
                        view.employees.forEach(e => {
                            view.employeeMap[e.id] = e;
                            var employeeTemp = {name: e.firstName + ' ' + e.lastName, employee: e};
                               employeeTemp.progressCurrent = 15;
                               employeeTemp.progressMax = 25;
                               employeeTemp.picture = view.GetProfilePictureUrl(e);
                               employeeTemp.timeFrames = [];
                            e.displayData = employeeTemp;
                            });
                        return view.loadEmployeePreferences()
                    }).then(response => {
                            view.preferences = response.data;
                            view.preferences.forEach(p => {
                                p.fromDate = p.date = view.$helpers.getMomentFromStringUTC(p.from, 'YYYY-MM-DDTHH:mm');
                                p.toDate = view.$helpers.getMomentFromStringUTC(p.to, 'YYYY-MM-DDTHH:mm');
                            });
                            return  view.loadBusinessUnits()
                        }).then(response => {
                            view.businessUnits = response.data;
                            view.businessUnitsMap = {};
                            view.businessUnits.forEach(b => view.businessUnitsMap[b.id] = b);
                            return view.loadSpots();
                        }).then(response => {
                            view.spots = response.data;
                            view.spotMap = {};
                            view.spots.forEach(s => view.spotMap[s.id] = s);
                            view.LoadGrid();
                            view.loading = false;
                        });
                    });
                this.$forceUpdate();

            },
            LoadGrid(){
                var view = this;
                this.columns = [];
                for(var x = 0; x < 12; x++){
                    var dateColumn = this.$helpers.getMomentUTC().locale('de').month(x);
                    var column = {header: {label: dateColumn.format('MMMM')}, date: dateColumn};
                    var rows = [];
                    for(var y = 1; y < this.$helpers.getMomentUTC().month(x).daysInMonth() + 1; y++){
                        var row = {header: {label: y < 10 ? '0' + y : y.toString()}};
                        var date = row.date = this.$helpers.getMomentUTC().month(x).date(y).hours(0).minutes(0);
                        var preferencesDate = this.preferences.filter(p => p.date.month() === date.month() && p.date.date() === date.date());
                        row.holidayCount = preferencesDate.filter(p => p.state === 1).length;
                        row.holidayRequestCount = preferencesDate.filter(p => p.state === 2).length;
                        row.sickCount = preferencesDate.filter(p => p.state === 3).length;
                        var event = Object.values(this.storeEventMap).find(entry => view.TimeDiff(date, entry.fromMoment) <= 24 * 60 * 60 * 1000 && view.TimeDiff(date, entry.toMoment) >= 0);
                        if(event) row.event = {header: event.name , description: event.name};
                        row.info = 'Row';
                        row.employees = this.employees.filter(e => preferencesDate.find(p => p.employeeId === e.id));
                        rows.push(row);
                    }
                    column.rows = rows;
                    this.columns.push(column);
                }
            },
            TimeDiff(a, b){
                return (parseInt(b.format('x'))) - (parseInt(a.format('x')));
            },
            OpenCalendarPopup($event, column, row){
                var view = this;
                this.dayInfoState = {
                    toggled: true,
                    column: column,
                    row: row,
                    employees: row.employees.slice(),
                    event: row.event,
                    elRelative: $event.currentTarget,
                    preferences: this.preferences,
                    date: row.date.clone(),
                    OnDeletePreference: this.PreferenceDeleted,
                    SwitchDate: this.OpenCalendarPopupByDate,
                };
            },
            OpenCalendarPopupByDate(date){
                var view = this;
                var column = this.columns.find(c => c.date.month() === date.month());
                var row = column.rows.find(r => r.date.date() === date.date());
                this.dayInfoState = {
                    toggled: true,
                    column: column,
                    row: row,
                    employees: row.employees.slice(),
                    event: row.event,
                    preferences: this.preferences,
                    date: row.date.clone(),
                    OnDeletePreference: this.PreferenceDeleted,
                    SwitchDate: this.OpenCalendarPopupByDate
                };
            },
            PreferenceDeleted(preference){
                this.preferences = this.preferences.filter(p => p.id !== preference.id);
                this.LoadGrid();
                this.$forceUpdate();
            },
            GetProfilePictureUrl(employee){
                if(!employee || !employee.employeePicture || !employee.employeePicture.server) return 'var(--contrast-1) no-repeat center/cover  url(../img/default.jpg)';
                var d = new Date();
                return 'var(--contrast-1) no-repeat center/cover  url(' + employee.employeePicture.server + '/api/file?id='+ employee.employeePicture.fileId +'&accessToken='+employee.employeePicture.accessToken +"&thumb=small"+ '&time='+Date.now()+')';
            },
            updateEmployees: function(data) {
                // set employee data
                //console.log(data);
                let overviewA = [];
                var i;
                var roster = this;
                let tEmployeeMap = {};
                for (i = 0; i < data.length; i++) {
                    data[i].shiftsDate = {};
                    data[i].picture = this.GetProfilePictureUrl(data[i]);
                    tEmployeeMap[data[i].id] = data[i];
                    overviewA.push(data[i]);

                }
                this.employeeMap = tEmployeeMap;
                this.employees = overviewA;
                this.employees.sort( this.sortByName );
                //this.employeesFiltered = this.employees.slice();

            },
            sortByName: function(a,b){
              var x = a.firstName + " " + a.lastName;
              var y = b.firstName + " " + b.lastName;
              if ( x.toUpperCase() < y.toUpperCase() ) return -1;
              if ( x.toUpperCase() > y.toUpperCase() ) return 1;
              return 0;
            },
            loadUIData: function(){
                let url = '/api/semi/uidata';
                return this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                });
            },
            updateUIData: function(data){
                this.uiData = data;
                let stateMap =  {};
                let typeMap = {};
                for(let i = 0; i < data.employeeAvailabilityStates.length; i++){
                    let employeeAvailabilityState = data.employeeAvailabilityStates[i];
                    stateMap[employeeAvailabilityState.id] = employeeAvailabilityState;
                    employeeAvailabilityState.show = true;
                }
                 for(let i = 0; i < data.employeeAvailabilityTypes.length; i++){
                    let employeeAvailabilityType = data.employeeAvailabilityTypes[i];
                    typeMap[employeeAvailabilityType.id] = employeeAvailabilityType;
                    employeeAvailabilityType.show = true;
                }
                this.employeeAvailabilityStates = data.employeeAvailabilityStates;
                this.employeeAvailabilityTypes = data.employeeAvailabilityTypes;
                this.employeeAvailabilityStateMap = stateMap;
                this.employeeAvailabilityTypeMap = typeMap;
            },
            loadActiveEmployees : function() {
                  let url = '/api/sec/employee';
                  let params = {
                      storeId: this.$store.state.storeId,
                      //activeAt: this.$store.state.rosterFromTo.from,
                      activeAt: "2019-09-24T00:00:00Z",
                  };


                  return this.axios({
                      method: 'get',
                      params: params,
                      headers: {
                          'AUTHORIZATION': "bearer "+this.$store.state.jwt
                      },
                      url: url
                  })

              },
            loadEmployeePreferences : function() {

            let url = '/api/sec/employeepreference';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');


            return this.axios({
              method: 'get',
              headers: {
                  'AUTHORIZATION': "bearer "+this.$store.state.jwt
              },
              url: url
            })
            },
            loadBusinessUnits : function() {

                let url = '/api/sec/businessunit';

                let params = {
                    storeId: this.$store.state.storeId,
                };


                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
            loadSpots : function() {

                let url = '/api/sec/spot';

                let params = {
                    storeId: this.$store.state.storeId,
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
            loadStoreEvents: function() {
                let url = '/api/sec/storeevent';
                let params = {
                    storeId: this.$store.state.storeId,
                    active: true,
                };
                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                });
            },
            updateStoreEvents: function(data){
                let i;
                let tstoreevents = {}
                for (i = 0; i < data.length; i++) {
                    let item = data[i];
                    item.fromMoment = this.$helpers.getMomentFromString(item.from);
                    item.toMoment = this.$helpers.getMomentFromString(item.to);

                    tstoreevents[data[i].id] = item;

                }
                this.storeEventMap = tstoreevents;
            },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .calendar-view{
        position: relative;
    }

    .calendar-view > .header{
        background:  var(--contrast-1);
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 60px;
        text-align: center;

    }

    .options{
        margin-top: 20px;
    }

    .options .label{
        text-align: center;
        border-radius: 5px;
        transition: .2s;
        height: 25px;
        width: 35px;
        border: 1px solid var(--contrast-5);
        border-right: none;
        border-radius: 0;
        line-height: 190%;
        cursor: pointer;
    }
    .options .label:first-child{
        border-radius: 5px 0 0 5px;
    }
    .options .label:last-child{
        border-radius: 0 5px 5px 0;
        border-right: 1px solid var(--contrast-5);
    }
    .options .label.selected, .options .label:hover{
        background: #6c8d25;
        color: white;
    }

    .grid{
        text-align: center;
        position: relative;
        height: 100%;
    }

    .column{
        display: inline-block;
        width: calc((100% / 12) - 20px);
        position: relative;
        box-shadow: inset 1px -1px 0 0px #cccccc,inset -1px -1px 0 0px #cccccc;
        float: left;
        left: 127px;
        margin-left: -1px;
        margin-bottom: 50px;
        margin-top: 50px;
    }

    .column > .header{

        display: block;
        width: 100%;
        height: 40px;
        box-shadow: inset -2px -2px 0 -1px #cccccc;
    }
    .column.today > .header{
        background: #e51c50;
    }
    .column.today > .header .label{
        color: white;
    }
    .column > .header .label{

        width: 100%;
        text-align: center;
        color: var(--contrast-4);
        font-weight: 400;
        font-size: 16px;
        line-height: 230%;
    }

    .row{
    display: block;
    width: 100%;
    height: 40px;
    position: relative;
    box-shadow: 0px -1px 0 0px #cccccc;
    margin-left: -1px;
    }
    .today-border{
        display: none;
    }
    .column.today .row.today .today-border{
        box-shadow: 1px -1px 0 0px #cccccc, inset 0 0 0 1px #e51c50;
        width: 100%;
        height: 100%;
        pointer-events: none;
        left: 0;
        top: 0;
        position:absolute;
        z-index: 5;
        display: inline-block;
    }
    .row > .header{
        display: block;
        width: 42px;
        margin-top: -1px;
        height: 40px;
        position: absolute;
        left: -40px;
        background: #cccccc;
        border-radius: 100px 0 0 100px;
        color: white;
        padding-left: 10px;
    }
    .row.today > .header{
        background: #e51c50;
    }
    .row > .header .label{
        color: white;
        font-size: 20px;
        line-height: 180%;
    }
    .row > .holiday{
        position: absolute;
        background: #6c8d25;
        height: 20px;
        width: 40px;
        left: 0px;
        top: 0px;
        border-radius: 100px;
        color: white;
        font-size: 10px;
        text-align: right;
        padding-right: 8px;
    }
    .row > .holiday-request{
        position: absolute;
        background: #ddbd1d;
        height: 20px;
        width: 20px;
        right: 40px;
        top: 0px;
        border-radius: 100px;
        color: white;
        font-size: 10px;
    }
    .row > .sick{
        position: absolute;
        background: #e51c50;
        height: 20px;
        width: 20px;
        right: 40px;
        top: 20px;
        border-radius: 100px;
        color: white;
        font-size: 10px;
    }
    .row > .info{
        position: absolute;
        top: 20px;
        left: 0px;
        width: 100%;
        font-size: 10px;
        text-align: left;
        padding-left: 5px;
    }
    .row > .event{
        position: absolute;
        background: #d9d9d9;
        height: 40px;
        width: 40px;
        right: 0;
        top: 0;
        font-size: 10px;
        padding: 5px;
        overflow: hidden;
        line-height: 9px;
    }
    .row > .event.shadow{
        position: absolute;
        box-shadow: inset -20px 0px 2px -17px #d9d9d9 !important;
        background: none;
        height: 40px;
        width: 40px;
        right: 0;
        top: 0;
        font-size: 10px;
        pointer-events: none;
    }

    .row.hide > *:not(.header):not(.event){
        opacity: 0;
        pointer-events: none;
    }

    .event-info{
        position: fixed;
        margin: auto;
        display: inline-block;
        background: white;
        box-shadow: 4px 4px 5px 3px  rgba(0,0,0,0.2);
        pointer-events: none;
        width: fit-content;
        padding: 5px;
        border-radius: 5px;
        opacity: 1;
        z-index: 10;
    }

    .event-info .header{
        position: relative;
        width: 100%;
        font-weight: 600;
        text-align: center;
    }

    .event-info .description{
        position: relative;
        width: 100%;
        text-align: center;
    }
    .loading{
	filter: none !important;
    position:absolute;
    box-sizing:content-box;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100vh);
    background: rgba(0,0,0,.5);
    z-index: 10;
  }
  .loading .fa-spinner{
    position:absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 50px;
    height: 50px;
    font-size: 50px;
    color: var(--contrast-3);
    animation-name: spin;
    animation-duration: 2000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes spin {
    from {
      transform:rotate(0deg);
    }
    to {
      transform:rotate(360deg);
    }
  }
</style>
